<form #workareaForm="ngForm">
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Oorzaak</mat-label>
                <mat-select
                    name="type"
                    (valueChange)="inputChanged($event)"
                    [disabled]="userIsContractor"
                    [(ngModel)]="workarea.extra.damage"
                    #type="ngModel"
                    errorState="type.errors?.required && (type.dirty || workareaForm.submitted)"
                    required>
                    <mat-option [value]="undefined" selected disabled>Type</mat-option>
                    @for (type of fieldOptions['damage']; track type) {
                        <mat-option [value]="type">{{ type }} </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Schade Locatie</mat-label>
                <mat-select
                    name="location_damage"
                    (valueChange)="inputChanged($event)"
                    [disabled]="userIsContractor"
                    [(ngModel)]="workarea.extra.location_damage"
                    #location_damage="ngModel"
                    errorState="location_damage.errors?.required && (location_damage.dirty || workareaForm.submitted)"
                    required>
                    <mat-option [value]="undefined" selected disabled>Schade Locatie</mat-option>
                    @for (type of fieldOptions['location_damage']; track type) {
                        <mat-option [value]="type">{{ type }} </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        @if ((Functionalities.CustomerProjectsParticipate | hasFunctionality) || userIsContractor) {
            <div class="col-24 col-md-12">
                <mat-form-field class="w-100" [floatLabel]="true">
                    <mat-label>Status</mat-label>
                    <mat-select name="status" [(ngModel)]="workarea.status_id" (ngModelChange)="statusChange($event)">
                        @for (status of statuses; track status) {
                            <mat-option [value]="status.id">
                                {{ status.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        }
        <div class="col-24 col-md-12">
            <ng-select
                [disabled]="userIsContractor"
                [items]="fieldOptions['district']"
                [closeOnSelect]="true"
                [(ngModel)]="workarea.extra.district"
                [hideSelected]="true"
                name="district"
                placeholder="Wijk"></ng-select>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Opmerkingen</mat-label>
                <textarea
                    [(ngModel)]="workarea.comments"
                    name="comments"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="4"></textarea>
            </mat-form-field>
        </div>
    </div>
    <mat-divider class="pb-4 pt-2"></mat-divider>
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Afzetting</mat-label>
                <mat-select name="roadblock" [(ngModel)]="workarea.extra.roadblock" [disabled]="userIsContractor">
                    <mat-option disabled>Afzetting</mat-option>
                    @for (item of fieldOptions['roadblock']; track item) {
                        <mat-option [value]="item">
                            {{ item }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Prioriteit</mat-label>
                <mat-select name="genpriority" [(ngModel)]="workarea.extra.genpriority" [disabled]="userIsContractor">
                    <mat-option disabled>Prioriteit</mat-option>
                    @for (item of fieldOptions['genpriority']; track item) {
                        <mat-option [value]="item">
                            {{ item }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Soort verharding</mat-label>
                <mat-select name="layertype" [(ngModel)]="workarea.extra.layertype" [disabled]="userIsContractor">
                    <mat-option disabled>Soort verharding</mat-option>
                    @for (item of fieldOptions['layertype']; track item) {
                        <mat-option [value]="item">
                            {{ item }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Soort opsluiting</mat-label>
                <mat-select name="enclosure" [(ngModel)]="workarea.extra.enclosure" [disabled]="userIsContractor">
                    <mat-option disabled>Soort opsluiting</mat-option>
                    @for (item of fieldOptions['enclosure']; track item) {
                        <mat-option [value]="item">
                            {{ item }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <mat-divider class="pb-4 pt-2"></mat-divider>
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Oppervlakte (m2)</mat-label>
                <input
                    matInput
                    type="number"
                    [(ngModel)]="workarea.extra.surface"
                    name="surface"
                    step="0.01"
                    [disabled]="userIsContractor" />
            </mat-form-field>
        </div>
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Lengte in meters</mat-label>
                <input
                    matInput
                    type="number"
                    [(ngModel)]="workarea.extra.length"
                    name="length"
                    step="0.01"
                    [disabled]="userIsContractor" />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Aantal</mat-label>
                <input
                    matInput
                    type="number"
                    [(ngModel)]="workarea.extra.amount"
                    name="amount"
                    step="0.01"
                    [disabled]="userIsContractor" />
            </mat-form-field>
        </div>
    </div>
</form>
